(function () {
  'use strict';
  var SL = window.StrikeLab || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || SL.moneyFormat || '${{amount}}';
    var rx = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, prec, thou, dec) {
      thou = thou || ','; dec = dec || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(prec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return d + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(rx); if (!m) return format;
    var v;
    switch (m[1]) {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(rx, v);
  }
  SL.formatMoney = formatMoney;

  function toast(msg) {
    var t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-show'); }, 2600);
  }

  /* ---------- Announcement rotator ---------- */
  $$('[data-rotator]').forEach(function (el) {
    var items = $$('.announce__item', el); if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      var cur = items[i]; i = (i + 1) % items.length; var nxt = items[i];
      cur.classList.remove('is-active'); cur.classList.add('is-out');
      nxt.classList.remove('is-out'); nxt.classList.add('is-active');
      setTimeout(function () { cur.classList.remove('is-out'); }, 600);
    }, 3800);
  });

  /* ---------- Mobile nav ---------- */
  var mnav = $('#MobileNav');
  function setNav(open) {
    if (!mnav) return;
    mnav.classList.toggle('is-open', open); mnav.setAttribute('aria-hidden', !open);
    document.body.classList.toggle('no-scroll', open);
  }
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { setNav(true); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setNav(false); }); });

  /* ---------- Cart ---------- */
  var drawer = $('#CartDrawer');
  var upsellData = [];
  try { upsellData = JSON.parse(($('#UpsellData') || {}).textContent || '[]'); } catch (e) { upsellData = []; }

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open); drawer.setAttribute('aria-hidden', !open);
    document.body.classList.toggle('no-scroll', open);
  }
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(function () { setDrawer(true); }); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setDrawer(false); setNav(false); } });

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0 && el.classList.contains('cart-bubble'); });
    if (!drawer) return cart;
    var body = $('[data-cart-items]', drawer);
    if (!cart.items.length) {
      body.innerHTML = '<div class="drawer__empty"><p>Your cart is empty.</p><a class="btn" href="' + (SL.routes.root || '/') + 'collections/all">SHOP THE LAB</a></div>';
    } else {
      body.innerHTML = cart.items.map(function (it, i) {
        var line = i + 1;
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<p class="line__meta">' + esc(it.variant_title) + '</p>' : '<p class="line__meta"></p>';
        var discs = (it.line_level_discount_allocations || []).map(function (d) { return '<p class="line__disc">' + esc(d.discount_application.title) + ' (−' + formatMoney(d.amount) + ')</p>'; }).join('');
        var was = it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '';
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
        return '<div class="line">' +
          '<a class="line__img" href="' + it.url + '">' + (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy" width="76" height="76">' : '') + '</a>' +
          '<div><a class="line__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' + variant + discs +
          '<div class="qty"><button type="button" class="qty__btn" data-line="' + line + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg></button><span>' + it.quantity + '</span><button type="button" class="qty__btn" data-line="' + line + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button></div></div>' +
          '<div class="line__price">' + was + '<strong>' + formatMoney(it.final_line_price) + '</strong><button type="button" class="line__rm" data-line="' + line + '" data-q="0">Remove</button></div>' +
          '</div>';
      }).join('');
    }
    // discounts (cart level)
    var dWrap = $('[data-cart-discounts]', drawer);
    var saved = cart.total_discount || 0;
    dWrap.innerHTML = saved > 0 ? '<div class="drawer__row"><span>Bundle savings</span><span>−' + formatMoney(saved) + '</span></div>' : '';
    $('[data-cart-subtotal]', drawer).textContent = formatMoney(cart.total_price);

    // shipping bar
    var th = SL.freeShippingThreshold || 0;
    var msg = $('[data-ship-msg]', drawer), fill = $('[data-ship-fill]', drawer);
    if (th > 0 && cart.total_price < th) {
      msg.innerHTML = 'You\'re <strong>' + formatMoney(th - cart.total_price) + '</strong> away from FREE shipping';
      fill.style.width = Math.max(6, Math.min(100, cart.total_price / th * 100)) + '%';
    } else {
      msg.innerHTML = cart.item_count ? '🔓 You\'ve unlocked <strong>FREE tracked shipping</strong>' : 'FREE tracked shipping on every order';
      fill.style.width = cart.item_count ? '100%' : '0%';
    }

    // upsell: first available product not in cart
    var up = $('[data-cart-upsell]', drawer);
    var inCart = cart.items.map(function (i) { return i.handle; });
    var pick = cart.items.length ? upsellData.filter(function (p) { return inCart.indexOf(p.handle) === -1; })[0] : null;
    if (pick) {
      up.hidden = false;
      up.innerHTML = '<p class="upsell__h">COMPLETE YOUR FIGHT KIT</p><div class="upsell">' +
        (pick.image ? '<img src="' + pick.image + '" alt="" loading="lazy" width="56" height="56">' : '<span></span>') +
        '<div><p class="upsell__t">' + esc(pick.title) + '</p><p class="upsell__p">' + formatMoney(pick.price) + '</p></div>' +
        (pick.single ? '<button type="button" class="btn btn--sm" data-upsell-add="' + pick.variant + '">+ ADD</button>' : '<a class="btn btn--sm" href="' + pick.url + '">CHOOSE</a>') +
        '</div>';
    } else { up.hidden = true; up.innerHTML = ''; }
    return cart;
  }

  /* Bundle gifts: $0 gift variants only stay in the cart while the bundle that earns them is there */
  function giftGuard(cart) {
    var g = SL.gifts || [];
    if (!g.length || !cart || !cart.items) return Promise.resolve(cart);
    var mainQty = 0;
    cart.items.forEach(function (it) { if (String(it.product_id) === String(SL.giftMainProduct)) mainQty += it.quantity; });
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      for (var k = 0; k < g.length; k++) {
        if (String(it.variant_id) !== String(g[k].variant)) continue;
        var allowed = mainQty >= g[k].min ? 1 : 0;
        if (it.quantity > allowed) {
          return fetch(SL.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: i + 1, quantity: allowed }) })
            .then(function (r) { return r.json(); }).then(giftGuard);
        }
      }
    }
    return Promise.resolve(cart);
  }
  SL.giftGuard = giftGuard;

  function refreshCart() {
    return fetch(SL.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(giftGuard).then(renderCart).catch(function () {});
  }

  function changeLine(line, qty) {
    return fetch(SL.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(giftGuard).then(renderCart);
  }

  function addItems(items) {
    return fetch(SL.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(); })
      .then(function () { setDrawer(true); });
  }
  SL.addItems = addItems;
  fetch(SL.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { return giftGuard(c).then(function (c2) { if (c2 !== c) renderCart(c2); }); }).catch(function () {});

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]');
      if (b) { b.disabled = true; changeLine(parseInt(b.dataset.line, 10), parseInt(b.dataset.q, 10)); return; }
      var u = e.target.closest('[data-upsell-add]');
      if (u) { u.disabled = true; addItems([{ id: parseInt(u.dataset.upsellAdd, 10), quantity: 1 }]).catch(function () { u.disabled = false; }); }
    });
  }

  /* ---------- Kit add ---------- */
  $$('[data-kit]').forEach(function (kit) {
    var btn = $('[data-kit-add]', kit);
    btn && btn.addEventListener('click', function () {
      var items = $$('[data-kit-variant]', kit).map(function (el) { return { id: parseInt(el.value, 10), quantity: 1 }; });
      btn.disabled = true;
      addItems(items).catch(function (err) { toast((err && err.description) || 'Could not add to cart'); }).then(function () { btn.disabled = false; });
    });
  });

  /* ---------- Product page ---------- */
  var ps = $('[data-product-section]');
  if (ps) {
    var data = {};
    try { data = JSON.parse(($('[data-product-json]') || {}).textContent || '{}'); } catch (e) {}
    var form = $('[data-product-form]', ps);
    var vInput = $('[data-variant-input]', ps);
    var qInput = $('[data-qty-input]', ps);
    var addBtn = $('[data-add-btn]', ps);
    var addText = $('[data-add-text]', ps);
    var addPrice = $('[data-add-price]', ps);
    var errEl = $('[data-form-error]', ps);
    var current = (data.variants || []).filter(function (v) { return String(v.id) === String(vInput.value); })[0] || (data.variants || [])[0];

    function selectedOptions() {
      return $$('.opt', ps).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function tierInfo() {
      var t = $('input[name="tier"]:checked', ps);
      return t ? { q: parseInt(t.value, 10), pct: parseFloat(t.dataset.pct || 0) } : { q: 1, pct: 0 };
    }
    function update() {
      if (!current) return;
      vInput.value = current.id;
      var ti = tierInfo();
      qInput.value = ti.q;
      // main price
      $('[data-price]', ps).textContent = formatMoney(current.price);
      var cmp = $('[data-compare]', ps), sv = $('[data-save]', ps);
      if (current.compare_at_price > current.price) { cmp.hidden = false; cmp.textContent = formatMoney(current.compare_at_price); sv.hidden = false; sv.textContent = 'SAVE ' + formatMoney(current.compare_at_price - current.price).replace(/\.00(?!\d)/, ''); }
      else { cmp.hidden = true; sv.hidden = true; }
      // tiers
      $$('.tier', ps).forEach(function (row) {
        var inp = $('input', row); var q = parseInt(inp.value, 10); var pct = parseFloat(inp.dataset.pct || 0);
        var full = current.price * q; var now = Math.round(full * (100 - pct) / 100);
        $('[data-tier-now]', row).textContent = formatMoney(now);
        var was = $('[data-tier-was]', row); was.textContent = formatMoney(full); was.hidden = pct <= 0;
        row.classList.toggle('is-checked', inp.checked);
      });
      // button
      var total = Math.round(current.price * ti.q * (100 - ti.pct) / 100);
      var addon = $('[data-addon-toggle]', ps);
      if (addon && addon.checked) total += addonPrice();
      addPrice.textContent = formatMoney(total);
      addBtn.disabled = !current.available;
      addText.textContent = current.available ? 'ADD TO CART' : 'SOLD OUT';
      var sp = $('[data-sticky-price]'); if (sp) sp.textContent = formatMoney(total);
      var cs = $('[data-cta-summary]', ps); if (cs) { cs.dataset.unit = cs.dataset.unit || cs.textContent.replace(/^\s*\d+\s*×\s*/, ''); cs.textContent = ti.q + ' × ' + cs.dataset.unit + (ti.q > 1 && !/S$/.test(cs.dataset.unit) ? 'S' : ''); }
      var ce = $('[data-cta-each]', ps); if (ce) { ce.hidden = ti.q < 2; ce.textContent = formatMoney(Math.round(current.price * (100 - ti.pct) / 100)) + ' EACH'; }
      var sb = $('[data-sticky-btn]'); if (sb) sb.firstChild.nodeValue = current.available ? 'ADD TO CART ' : 'SOLD OUT ';
      $$('[data-option-label]', ps).forEach(function (el, i) { el.textContent = ': ' + (selectedOptions()[i] || ''); });
    }
    SL._pdpUpdate = update;

    $$('[data-option]', ps).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var sel = selectedOptions();
        var match = data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
        if (match) {
          current = match;
          if (match.featured_media) goToMedia(match.featured_media);
          if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', match.id); history.replaceState({}, '', u); }
        }
        update();
      });
    });
    $$('input[name="tier"]', ps).forEach(function (i) { i.addEventListener('change', update); });

    // addon
    var addonWrap = $('[data-addon]', ps);
    function addonPrice() {
      var el = addonWrap && $('[data-addon-variant]', addonWrap); if (!el) return 0;
      var src = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
      return parseInt(src.dataset.price || 0, 10);
    }
    if (addonWrap) {
      var tog = $('[data-addon-toggle]', addonWrap);
      tog.addEventListener('change', update);
      var sel = $('select[data-addon-variant]', addonWrap);
      if (sel) sel.addEventListener('change', function () { tog.checked = true; update(); });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errEl.hidden = true;
      var items = [{ id: parseInt(vInput.value, 10), quantity: parseInt(qInput.value, 10) || 1 }];
      var tog = $('[data-addon-toggle]', ps);
      if (tog && tog.checked) { var av = $('[data-addon-variant]', ps); if (av) items.push({ id: parseInt(av.value, 10), quantity: 1 }); }
      addBtn.disabled = true; addText.textContent = 'ADDING…';
      addItems(items).catch(function (err) {
        errEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; errEl.hidden = false;
      }).then(function () { addBtn.disabled = !current.available; addText.textContent = current.available ? 'ADD TO CART' : 'SOLD OUT'; });
    });

    // gallery
    var track = $('[data-gal-track]', ps);
    var slides = $$('.gal__slide', ps);
    var thumbs = $$('[data-thumb]', ps);
    var dots = $$('.gal__dots span', ps);
    function goTo(i) { if (!track) return; track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
    function goToMedia(id) { slides.forEach(function (s, i) { if (String(s.dataset.mediaId) === String(id)) goTo(i); }); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.thumb, 10)); }); });
    function curIdx() { return track ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    var gp = $('[data-gal-prev]', ps), gn = $('[data-gal-next]', ps);
    if (gp) gp.addEventListener('click', function () { var i = curIdx() - 1; goTo(i < 0 ? slides.length - 1 : i); });
    if (gn) gn.addEventListener('click', function () { var i = curIdx() + 1; goTo(i >= slides.length ? 0 : i); });
    if (track) {
      var tmr;
      track.addEventListener('scroll', function () {
        clearTimeout(tmr);
        tmr = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
          dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
        }, 60);
      }, { passive: true });
    }

    // sticky ATC
    var sticky = $('[data-sticky-atc]');
    var buy = $('[data-buy]', ps);
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', !show);
      }).observe(buy);
      $('[data-sticky-btn]').addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }

    // delivery estimate (business days)
    var dl = $('[data-delivery]', ps);
    if (dl) {
      var addBiz = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
      var o = { month: 'short', day: 'numeric' };
      var now = new Date();
      var a = addBiz(now, parseInt(dl.dataset.min, 10) || 7).toLocaleDateString(undefined, o);
      var b = addBiz(now, parseInt(dl.dataset.max, 10) || 15).toLocaleDateString(undefined, o);
      $('[data-delivery-range]', dl).textContent = a + ' – ' + b;
    }

    update();
  }

  /* ---------- Sliders ---------- */
  $$('[data-slide]').forEach(function (b) {
    b.addEventListener('click', function () {
      var sec = b.closest('section'); var sl = $('[data-slider]', sec); if (!sl) return;
      var card = sl.firstElementChild; var w = card ? card.getBoundingClientRect().width + 16 : 300;
      sl.scrollBy({ left: w * parseInt(b.dataset.slide, 10), behavior: 'smooth' });
    });
  });

  /* ---------- Track order ---------- */
  $$('[data-track]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = (f.num.value || '').trim(); if (!n) return;
      window.open('https://t.17track.net/en#nums=' + encodeURIComponent(n), '_blank', 'noopener');
    });
  });

  /* ---------- Reveal ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var els = $$('.sec-head, .p-card, .kit, .nfeat__item, .step, .spot__media, .spot__copy, .use, .compare, .acc, .cta');
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('reveal'); io.observe(el); } });
  }

  document.addEventListener('shopify:section:load', function () { location.reload(); });
})();
